
import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'IssuesEntity/List', method: 'GET', body: null, token: token })
}
